import { useContext } from "react";
import { EnvironmentContext } from "../context/environmentContext";

const useConfig = () => {
  const { environmentVars } = useContext(EnvironmentContext);
  return environmentVars;
};

export default useConfig;
